import { BrowserRouter, Routes, Route } from "react-router-dom";

// import AdminAuthCheck from "../../components/AuthCheck/AdminAuthCheck";
import ClientLayout from "../../components/ClientLayout";
import CreateAccount from "../../views/createAccount";
import VehicleCreation from "../../views/vehicleCreation";
import Login from "../../views/login";
import ForgetPassword1 from "../../views/forget-password-1";
import ForgetPassword2 from "../../views/forget-password-2";
import ForgetPassword3 from "../../views/forget-password-3";
import AboutUs from "../../views/aboutUs";
import VehicleView from "../../views/vehicleView";
import VehicleEdit from "../../views/vehicleView/vehicleEdit";
// import BusinessHours from "../../views/businessHours";
import Dashboard from "../../views/dashboard";
import PrivacyPolicy from "../../views/privacyPolicy";
import TermsConditions from "../../views/termsConditions";
import ProtectedRoute from "../../views/protectedRoute";
import Profile from "../../views/profile";
import EditProfile from "../../views/profile/editProfile";
import ChangePassword from "../../views/profile/changePassword";
import Help from "../../views/help";
import Completion from "../../views/Completion";
import Notifications from "../../views/notifications";
// import PaymentLogs from "../../views/paymentLogs";
// import PaymentDetails from "../../views/paymentLogs/paymenDetails";
import Ride from "../../views/ride";
import UpcomingDetails from "../../views/ride/upcomingDetails";
import PendingBookings from "../../views/ride/pendingBookings";
import CompletedBooking from "../../views/ride/completedBooking";
// import RideDetails from "../../views/RideDetails";
import { useSelector } from "react-redux";
import socket from "../socket/index";
import { useEffect } from "react";
import useUpdateLocation from "../../hooks/UpdateLocation";
import HistoryBookings from "../../views/historyBookings";

const MyRouter = () => {
  const token = useSelector((state) => state.user.userToken);
  const user = useSelector((state) => state.user.userData);

  useEffect(() => {
    if (token) {
      socket.emit("setupChauffeur", user);
    }
    // eslint-disable-next-line
  }, []);
    useUpdateLocation();
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        {/* <Route
          path="/"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <Homepage />
            </ClientLayout>
          }
        /> */}

        <Route path="/createAccount" index element={<CreateAccount />} />
        <Route
          path="/vehicleCreation"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{
                  title: "vehicleCreation",
                  description: "Some Description.",
                }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <VehicleCreation />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        {/* <Route path="/vehicleCreation" index element={<VehicleCreation />} /> */}

        {/* <Route path="/vehicleView" index element={<VehicleView />} />
        <Route path="/vehicleEdit" index element={<VehicleEdit />} /> */}

        <Route
          path="/vehicleView"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{
                  title: "vehicleView",
                  description: "Some Description.",
                }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <VehicleView />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/vehicleEdit"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{
                  title: "vehicleEdit",
                  description: "Some Description.",
                }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <VehicleEdit />
              </ClientLayout>
            </ProtectedRoute>
          }
        />

        <Route path="/login" index element={<Login />} />
        <Route path="/forget-password-1" index element={<ForgetPassword1 />} />
        <Route path="/forget-password-2" index element={<ForgetPassword2 />} />
        <Route path="/forget-password-3" index element={<ForgetPassword3 />} />

        <Route
          path="/aboutUs"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <AboutUs />
            </ClientLayout>
          }
        />
        <Route
          path="/"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <Dashboard />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/businessHours"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <BusinessHours />
            </ClientLayout>
          }
        /> */}
        {/* <Route
          path="/paymentLogs"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <PaymentLogs />
            </ClientLayout>
          }
        /> */}
        {/* <Route
          path="/paymentLogs/:id"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <PaymentDetails />
            </ClientLayout>
          }
        /> */}
        <Route
          path="/historyBookings"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <HistoryBookings />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ride"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <Ride />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ride/:id"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <UpcomingDetails />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ride/pendingBookings/:id"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <PendingBookings />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ride/completedBooking/:id"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <CompletedBooking />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/rideDetails/:id"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <RideDetails />
            </ClientLayout>
          }
        /> */}
        <Route
          path="/privacyPolicy"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <PrivacyPolicy />
            </ClientLayout>
          }
        />
        <Route
          path="/termsConditions"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <TermsConditions />
            </ClientLayout>
          }
        />
        <Route
          path="/profile"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <Profile />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/editProfile"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <EditProfile />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/changePassword"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <ChangePassword />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/help"
          index
          element={
            <ClientLayout
              head={{ title: "Dashboard", description: "Some Description." }}
              headerStyle={{ height: { base: "40px", md: 14 } }}
            >
              <Help />
            </ClientLayout>
          }
        />
        <Route
          path="/completion"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <Completion />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          index
          element={
            <ProtectedRoute>
              <ClientLayout
                head={{ title: "Dashboard", description: "Some Description." }}
                headerStyle={{ height: { base: "40px", md: 14 } }}
              >
                <Notifications />
              </ClientLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
export default MyRouter;
